import React from "react";
import { DashboardLayout, BaseLayout } from "@layouts/index";
import { useSessionStorage } from "../../../hooks";

const SecuringBooking: React.FC = () => {
  const [user] = useSessionStorage("user", {});

  const LoaderContent = () => (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700&family=DM+Sans:wght@400;500&display=swap');

        .securing-wrapper {
          font-family: 'DM Sans', sans-serif;
          background: #fff;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .securing-inner {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
        }

        /* Spinner */
        .spinner-ring {
          width: 56px;
          height: 56px;
          border: 3.5px solid #e0f5f0;
          border-top-color: #10c9a0;
          border-radius: 50%;
          animation: spin 0.9s linear infinite;
          margin-bottom: 8px;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .securing-title {
          font-family: 'Sora', sans-serif;
          font-size: 1.55rem;
          font-weight: 700;
          color: #111827;
          letter-spacing: -0.3px;
          margin: 0;
        }

        .securing-subtitle {
          font-size: 0.95rem;
          color: #6b7280;
          margin: 0;
        }

        /* Animated dots */
        .dots {
          display: flex;
          align-items: center;
          gap: 6px;
          margin: 6px 0 2px;
        }

        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #10c9a0;
          animation: bounce 1.2s ease-in-out infinite;
        }

        .dot:nth-child(1) { animation-delay: 0s; }
        .dot:nth-child(2) { animation-delay: 0.2s; }
        .dot:nth-child(3) { animation-delay: 0.4s; }

        @keyframes bounce {
          0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1); }
        }

        .securing-note {
          font-size: 0.85rem;
          color: #9ca3af;
          margin: 0;
        }
      `}</style>

      <div className="securing-wrapper">
        <div className="securing-inner">
          <div className="spinner-ring" />
          <h2 className="securing-title">Securing your booking...</h2>
          <p className="securing-subtitle">
            Please wait while we confirm your reservation
          </p>
          <div className="dots">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
          </div>
          <p className="securing-note">This should only take a moment</p>
        </div>
      </div>
    </>
  );

  return user && user?.id ? (
    <DashboardLayout>
      <LoaderContent />
    </DashboardLayout>
  ) : (
    <BaseLayout>
      <LoaderContent />
    </BaseLayout>
  );
};

export default SecuringBooking;
